import { Component, Input } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { ConnectionService } from '../../services/connection-service';
import { Broadcaster } from '../broadcaster';
import { ApiClientConstant } from '@cureskin/api-client';

@Component({
    selector: 'support-ticket-list',
    templateUrl: './ticket-list.html',
    styleUrls: ['./ticket-list.scss'],
    standalone: false
})
export class SupportTicketListComponent {
  @Input('user')
  set onUpdateUser(user: any) {
    if (!user) {
      return;
    }
    this.user = user;
    this.loadTicket(this.filter);
  }
  user: string;
  supportTicket: Array<any> = [];
  filter: string = 'Active';
  fetching: boolean = false;
  constructor(public appConfig: AppConfig, private connectionService: ConnectionService, private broadcaster: Broadcaster) {}

  async loadTicket(filter: string): Promise<void> {
    if (this.fetching) return;
    this.fetching = true;
    try {
      const filterCondition = this.getFilterCondition(filter);
      this.supportTicket = await this.connectionService.findSupportTicket({
        where: { user: this.user, ...filterCondition },
        include: ['supportQuestion', 'SBAR'],
        project: ['status', 'completed', 'supportQuestion.question' as 'supportQuestion', 'SBAR', 'user', 'operatorAnalysisResponse', 'llmResponse'],
        descending: 'createdAt',
      });
      if(this.supportTicket.length > 0) {
        this.supportTicket = this.supportTicket.filter((ticket: any) => {
          return this.filterForDissatisfaction(ticket) || this.filterForDiscomfort(ticket);
        });
      }
    } catch (error) {
      this.broadcaster.broadcast('NOTIFY', { message: `Error fetching tickets: ${error.message}`, type: this.appConfig.Shared.Toast.Type.ERROR })
    } finally {
      this.fetching = false;
    }
  }
  async changeFilter(event: string): Promise<void> {
    this.filter = event;
    await this.loadTicket(this.filter);
  }

  getFilterCondition(filter: string): object {
    const filterCondition: { [key: string]: any } = {};
    if(this.filter === 'Spam') {
      filterCondition.status = this.appConfig.Shared.Ticket.Status.Pending;
      filterCondition.treeCompleted = false;
      filterCondition.openTime = { $exists: false };
    }
    if (this.filter === 'Active') {
      filterCondition.status = this.appConfig.Shared.Ticket.Status.Pending;
      filterCondition.treeCompleted = true;
      filterCondition.openTime = { $exists: true };
    }
    if(this.filter === 'All') {
      filterCondition.status = {
        $in: [
          this.appConfig.Shared.Ticket.Status.Pending,
          this.appConfig.Shared.Ticket.Status.Completed,
          this.appConfig.Shared.Ticket.Status.RequestClosure
        ]
      }
    }
    if (this.filter === 'Completed') {
      filterCondition.status =  {
        $in: [
          this.appConfig.Shared.Ticket.Status.Completed,
          this.appConfig.Shared.Ticket.Status.RequestClosure
        ]
      }
    }
    return filterCondition;
  }
  filterForDissatisfaction(ticket: any): boolean {
    return ticket.get('operatorAnalysisResponse')?.subcategory === 'dissatisfaction related' || (ticket.get('llmResponse')?.subcategory== 'dissatisfaction related' && ticket.get('operatorAnalysisResponse')?.subcategory === undefined);
  }
  filterForDiscomfort(ticket: any): boolean {
    return ticket.get('operatorAnalysisResponse')?.category === 'discomfort' || (ticket.get('llmResponse')?.category== 'discomfort' && ticket.get('operatorAnalysisResponse')?.category === undefined);
  }
}
